module.exports = __webpack_public_path__ + "img/intro.427673ee.jpg";